import { Container, FormContainer, LoginBox, Logo } from "./styles";
import capivara from "../../../../assets/images/capivara.png";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "../../../../components/inputs";
import { Page } from "../../../../components/page-base";
import { toast } from "react-toastify";
import { LoginService } from "../../services";

export const EmailResetPassword: React.FC = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState<string>("");
  const [isDisabled, setIsDisbled] = useState<boolean>(true);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsDisbled(true);
    await LoginService.resetPassword(email).then((r) => {
      if (r) {
        toast.success(r);
        setTimeout(() => {
          navigate("/");
        }, 1000);
      } else {
        toast.error("Erro ao enviar link de redefinição.");
        setIsDisbled(false);
      }
    });
  };
  useMemo(() => {
    if (email.length < 12) {
      setIsDisbled(true);
    } else {
      setIsDisbled(false);
    }
  }, [email]);
  const handleEmailChange = (value: string) => {
    setEmail(value.toLowerCase());
  };
  return (
    <Container>
      <LoginBox>
        <Logo>
          <img src={capivara} alt="Logo" />
        </Logo>
        <form onSubmit={handleSubmit}>
          <FormContainer>
            <Input.Label
              label="Informe o seu email de acesso:"
              placeholder=""
              setValue={handleEmailChange}
              value={email}
              type="email"
              required
            />

            <Page.Button
              type="submit"
              label="Enviar link de redefinição"
              disabled={isDisabled}
            />
          </FormContainer>
        </form>
      </LoginBox>
    </Container>
  );
};
